import React from "react";
import { Link } from "react-router-dom";

import { Button } from "reactstrap";

const Page500 = () => (
  <div className="text-center">
    <h1 className="display-1 font-weight-bold">500</h1>
    <p className="h1">Internal Server Error.</p>
    <p className="h2 font-weight-normal mt-3 mb-4">
      O servidor encontrou algo inesperado que não permitiu que completetasse a requisição.
    </p>
    <Link to="/">
      <Button color="success" size="lg">
        Volte para Home.
      </Button>
    </Link>
  </div>
);

export default Page500;
